
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaiairportinovacab() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Airport Innova Cab',
        heading: 'Prince Cabs: Pune to Mumbai Airport Innova Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Mumbai Airport Innova Cab services, perfect for business travelers, family trips, and group journeys. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities to ensure a safe and comfortable ride on the Pune–Mumbai Expressway. With professional chauffeurs, timely pickups, and flexible schedules, we make sure you reach Mumbai Airport (T1 & T2) on time without any stress. Experience comfort, reliability, and affordability with Prince Cabs’ trusted Innova cab service from Pune to Mumbai Airport.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

   "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic monument overlooking the Arabian Sea. It commemorates the visit of King George V and Queen Mary to India. The Indo-Saracenic architecture attracts tourists worldwide. Ferries to Elephanta Caves depart from here, adding to its importance. The site is always bustling with locals, street vendors, and photographers. At sunset, the monument glows beautifully, making it perfect for evening visits."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Its curved row of lights resembles a sparkling necklace at night. Locals and tourists gather here for evening strolls, jogging, and to enjoy sea breezes. The spot is especially famous for mesmerizing sunsets. During monsoon, crashing waves create a dramatic spectacle. Marine Drive perfectly captures Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, Elephanta Caves are located on Elephanta Island, about an hour’s ferry ride from the Gateway of India. Dating back to the 5th–6th century, the caves feature rock-cut sculptures of Lord Shiva, including the iconic Trimurti. The site showcases India’s ancient artistry and spiritual depth. Surrounded by greenery and sea views, it offers both history and nature. It is a must-visit for culture and heritage lovers."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887 in Gothic Revival style, it features domes, stained glass, and intricate carvings. At night, the building is illuminated, creating a spectacular sight. It is not only a transport hub but also an architectural masterpiece. Tourists admire its grandeur while experiencing Mumbai’s lifeline—local trains. CST is a blend of history and modern energy."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an engineering marvel and an iconic symbol of modern Mumbai. This 8-lane cable-stayed bridge connects South Mumbai with the western suburbs. Driving across offers stunning views of the Arabian Sea and skyline. At night, the illuminated structure looks breathtaking. It significantly reduces travel time for commuters. The Sea Link showcases Mumbai’s progress and infrastructure brilliance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its lively atmosphere and street food stalls. Vendors sell favorites like pav bhaji, bhel puri, and ice gola. The beach is also known for celebrity homes nearby, drawing Bollywood fans. Families gather here in the evenings to enjoy sea breezes and sunset views. During weekends, the beach is crowded with tourists and locals alike. It is a must-visit coastal spot in Mumbai."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet off Worli. Dedicated to Pir Haji Ali Shah Bukhari, it blends Indo-Islamic architecture with spiritual significance. The shrine is accessible via a narrow causeway during low tide. People of all faiths visit to seek blessings and peace. The dargah’s sea-facing setting creates a magical ambiance. It is both a spiritual and architectural landmark of Mumbai."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Spread over 87 sq. km, Sanjay Gandhi National Park is a green oasis within Mumbai. It houses leopards, deer, and migratory birds. Inside the park, the Kanheri Caves feature Buddhist monasteries, stupas, and carvings dating back to the 1st century BC. Trekkers and families enjoy its trails, toy train, and boating. It is rare to find such biodiversity within a city. The park is a blend of nature, history, and recreation."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market, perfect for shopping and dining. It offers trendy clothes, jewelry, handicrafts, and antiques at bargain prices. Tourists also enjoy iconic cafés like Leopold Café and Café Mondegar. The area buzzes with energy from morning till late night. It reflects Mumbai’s cosmopolitan lifestyle. Shopping here is an essential part of the Mumbai experience."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts lakhs of devotees daily, including celebrities and politicians. The gold-plated dome and intricately carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. It is believed that prayers here are always fulfilled. The temple is a symbol of faith and devotion in Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for its Ganesh Visarjan celebrations. Families visit to enjoy Mumbai’s iconic street food like pav bhaji and kulfi. The beach offers evening relaxation with views of Marine Drive. Festivals and fairs add to its vibrant atmosphere. It is an integral part of Mumbai’s social and cultural life. Girgaon Chowpatty is both fun-filled and spiritual."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Spread over 520 acres, Film City in Goregaon is the hub of Bollywood film and TV production. It has multiple studios, sets, and artificial landscapes. Guided tours allow visitors to explore behind-the-scenes of movies and shows. Fans enjoy spotting shooting locations and sets. Film City highlights Mumbai’s identity as the entertainment capital of India. It is a unique attraction for cinema lovers."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and modern skyscrapers. It is a peaceful spot for birdwatching, with species like kingfishers and herons. Locals enjoy morning walks and photography here. The lake is especially picturesque during monsoon. Its calm waters provide a natural escape from the city’s hustle. Powai Lake is an underrated gem of Mumbai."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "Located near Gorai, the Global Vipassana Pagoda is a massive meditation dome built in Burmese style. It houses relics of Buddha and can accommodate 8,000 meditators. The golden dome is one of the largest stone structures without supporting pillars. Visitors attend meditation sessions and admire its architecture. The serene seaside location enhances its spiritual appeal. It is a symbol of peace and enlightenment."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "The Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. It offers advanced projection shows about stars, planets, and space exploration. The adjoining Science Centre features interactive exhibits and galleries on science and technology. Families and students love its engaging displays. The dome-shaped auditorium hosts cultural and scientific programs. It is an inspiring destination for curious minds."
  }
],

"services": [
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Book a reliable and comfortable Innova cab for your drop from Pune to Mumbai Airport. Our service ensures on-time pickups, smooth highway travel, and ample space for luggage. Ideal for solo travelers, families, and business professionals looking for stress-free airport transfers with experienced chauffeurs."
    },
    {
        "name": "Best Innova Cab Service from Pune to Mumbai Airport",
        "description": "Experience top-rated Innova cab service for Pune to Mumbai Airport transfers. We provide clean, well-maintained vehicles with professional drivers who prioritize punctuality and comfort. Enjoy a hassle-free journey on the expressway in a spacious Innova, perfect for early morning or late-night flights."
    },
    {
        "name": "Pune to Mumbai Airport Innova Crysta Cab",
        "description": "Travel in style from Pune to Mumbai Airport with our premium Innova Crysta cab. Known for its luxury and comfort, the Crysta offers plush seating, smooth ride quality, and top-notch safety features, ensuring your airport drop is as pleasant as possible, whether you're flying domestic or international."
    },
    {
        "name": "Pune to Mumbai Airport Innova Crysta Taxi Fare",
        "description": "Get transparent and competitive Innova Crysta taxi fares from Pune to Mumbai Airport. Our pricing includes tolls and parking (optional), and there are no hidden charges. Ideal for families and professionals seeking value and comfort in a premium vehicle for their airport journey."
    },
    {
        "name": "Pune to Mumbai International Airport Innova Crysta Cab",
        "description": "For international flyers, our Innova Crysta cab from Pune to Mumbai International Airport offers the perfect combination of space, reliability, and luxury. Enjoy timely pickups, extra luggage capacity, and courteous drivers who are familiar with airport terminals and procedures for hassle-free drop-offs."
    },
    {
        "name": "Pune to Mumbai Airport Innova Dzire Alternative",
        "description": "Looking for more space and comfort than a Dzire? Our Innova cabs from Pune to Mumbai Airport are the perfect upgrade. With more legroom, luggage space, and better suspension, the Innova provides a smoother and more premium ride for airport travel, especially for groups or families."
    },
    {
        "name": "Pune to Mumbai Airport Family Innova",
        "description": "Plan your family trip to Mumbai Airport with our dedicated Innova cabs. Spacious, air-conditioned, and fitted with all amenities, our vehicles are ideal for families with kids, elders, and extra baggage. Our drivers ensure a safe, comfortable, and punctual ride every time."
    },
    {
        "name": "Pune to Mumbai Airport Affordable Innova",
        "description": "Get budget-friendly Innova cab services from Pune to Mumbai Airport without compromising on comfort. Our affordable packages include well-maintained vehicles, experienced drivers, and on-time service, making it a cost-effective option for airport travel in style."
    },
    {
        "name": "Luxury Innova Pune to Mumbai Airport",
        "description": "Choose our luxury Innova Crysta for a premium Pune to Mumbai Airport transfer experience. Enjoy features like captain seats, plush interiors, bottled water, and courteous drivers. Perfect for business travelers and families who want top-tier comfort, style, and reliable service."
    }
],
"tableData": [
    ["Pune to Mumbai Airport Drop Innova", "Best Innova Cab Service from Pune to Mumbai Airport"],
    ["Pune to Mumbai Airport Innova Crysta Cab", "Pune to Mumbai Airport Innova Crysta Taxi Fare"],
    ["Pune to Mumbai International Airport Innova Crysta Cab", "Pune to Mumbai Airport Innova Dzire Alternative"],
    ["Pune to Mumbai Airport Family Innova", "Pune to Mumbai Airport Affordable Innova"],
    ["Luxury Innova Pune to Mumbai Airport", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Airport Innova Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and timely Toyota Innova cab services from Pune to Mumbai Airport (Chhatrapati Shivaji Maharaj International Airport – T1 & T2). Whether you're heading for a flight or arriving into the city, our cabs ensure a hassle-free journey with professional service, comfort, and punctuality at the core of your travel experience."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Travel for Families and Groups",
        "WhyChoosedescription": "Our Innova and Innova Crysta vehicles are ideal for airport transfers, especially for groups, families, and travelers with heavy luggage. Enjoy ample legroom, smooth suspension, reclining seats, AC comfort, and generous boot space—making the 3.5 to 4.5-hour journey smooth and relaxing."
    },
    {
        "WhyChooseheading": "Professional Drivers with Airport Transfer Expertise",
        "WhyChoosedescription": "Our experienced drivers are well-versed with Pune–Mumbai Expressway and familiar with traffic patterns and airport terminal access protocols. They ensure safe driving, timely pickup, and drop-offs, even during odd hours or peak traffic conditions—so you never miss a flight or wait unnecessarily."
    },
    {
        "WhyChooseheading": "Flexible Pickup & Drop-off Timings, 24/7 Availability",
        "WhyChoosedescription": "Book your Pune to Mumbai Airport Innova cab at any time—day or night. We operate 24/7, offering pickup from any location in Pune including Hadapsar, Kothrud, Baner, Hinjewadi, and more, and drop-off at your specific terminal (T1 – Domestic or T2 – International)."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Last-Minute Surprises",
        "WhyChoosedescription": "We provide upfront pricing for one-way and round trips with all-inclusive quotes that cover tolls, parking, driver allowance, and fuel. You can also choose per km billing or fixed-rate packages depending on your convenience—with no hidden charges."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Innova cabs undergo rigorous cleaning and sanitization before every airport transfer. Our vehicles are equipped with seat belts, climate control, and essential safety features, ensuring you travel in a safe, hygienic, and worry-free environment."
    },
    {
        "WhyChooseheading": "Easy Booking & 24/7 Customer Support",
        "WhyChoosedescription": "Booking a Pune to Mumbai Airport Innova cab is easy via call, WhatsApp, or online portal. Our customer support team is available round the clock to assist with urgent bookings, rescheduling, flight delays, and special requests, making your airport transfer stress-free and smooth."
    }
]



















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova cab service from Pune to Mumbai Airport?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable Innova and Innova Crysta cab services from Pune to Mumbai Airport for both domestic and international travelers.',
    },
    {
        question: 'What is the fare for a Pune to Mumbai Airport Innova cab?',
        answer: 'The fare for a one-way Innova cab from Pune to Mumbai Airport starts from ₹4,200. Final pricing depends on the pickup time, type of Innova, and any additional stops.',
    },
    {
        question: 'How long does it take to reach Mumbai Airport from Pune by Innova?',
        answer: 'The journey typically takes 3.5 to 5 hours depending on traffic conditions and pickup location in Pune. We ensure timely drop-offs to match your flight schedule.',
    },
    {
        question: 'Is Innova Crysta available for Pune to Mumbai Airport drop?',
        answer: 'Absolutely! You can choose between standard Toyota Innova and premium Innova Crysta with captain seats, extra luggage space, and added comfort.',
    },
    {
        question: 'Are the drivers experienced and familiar with airport routes?',
        answer: 'Yes, our drivers are experienced, professional, and well-versed with both T1 (Domestic) and T2 (International) terminals at Mumbai Airport.',
    },
    {
        question: 'Can I book an early morning or late-night Innova cab to Mumbai Airport?',
        answer: 'Yes, Prince Cabs operates 24/7. You can book an Innova cab for airport transfers at any time—early morning, late night, or during peak hours.',
    },
    {
        question: 'How do I book a Pune to Mumbai Airport Innova cab?',
        answer: 'You can book online through our website or call our support team. Just share your flight details and pickup time, and we’ll handle the rest.',
    },
];

const testimonials = [
    {
        name: "Mr. Vikram Thakur",
        position: "Frequent Flyer",
        text: "I always book an Innova from Prince Cabs for my Pune to Mumbai Airport travel. The car is clean, the driver is punctual, and they never miss a flight deadline.",
        image: "/img/testimonial/testimonial-thumb-airport-1.png",
    },
    {
        name: "Mrs. Neeta Shah",
        position: "Senior Citizen",
        text: "We had a very early morning flight and Prince Cabs arranged an Innova Crysta. The ride was smooth and on time. Excellent airport cab service!",
        image: "/img/testimonial/testimonial-thumb-airport-2.png",
    },
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Innova Cab",
  "image": "https://princecab.com/assets/images/pune-to-mumbai-airport-innova-cab.jpg",
  "description": "Book Pune to Mumbai Airport Innova Crysta cab with Prince Cabs for a comfortable, reliable, and affordable airport transfer. Available for family trips and luxury rides.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2900",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mumbai-airport-innova-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Airport Innova Cab | Reliable Airport Transfer | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mumbai Airport Innova Crysta cab with Prince Cabs for a comfortable, reliable, and affordable airport transfer. Available for family trips and luxury rides."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Drop Innova, Best Innova Cab Service from Pune to Mumbai Airport, Pune to Mumbai Airport Innova Crysta Cab, Pune to Mumbai Airport Innova Crysta Taxi Fare, Pune to Mumbai International Airport Innova Crysta Cab, Pune to Mumbai Airport Innova Dzire Alternative, Pune to Mumbai Airport Family Innova, Pune to Mumbai Airport Affordable Innova, Luxury Innova Pune to Mumbai Airport"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiairportinovacab ;